import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { Images } from "./../../assets/common";
import AddSikiModal from "./../../components/AddSikiModal";
import "./index.scss";
import QrCode from "../../components/QrCode";
import { getQueryStringParams } from "./../../constants/function";
import { useTheme as useAppTheme } from "../../context/ThemeContext";

export default function (props) {
  const { getCurrentBranding } = useAppTheme();
  const brandName = getCurrentBranding()?.appName || "SIKI";
  const params = getQueryStringParams(props.location.search);
  const [open, setOpen] = useState(false);
  const [HBARORUDSC, setHBARORUDSC] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [fundingLink, setFundLink] = useState(null);
  const classes = {
    paper: {
      background: "blue",
    },
  };

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const handleClose = (fundLink) => {
    setOpenModal(false);
    setFundLink(fundLink ? fundLink : null);
  };

  return (
    <Box sx={{ margin: "10px", position: "relative", height: "90vh" }}>
      <div align="center">
        <Typography color="textPrimary" className="fs-24" align="center">
          Add {brandName} token
        </Typography>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            setHBARORUDSC("hbar");
            setOpen(true);
          }}
        >
          <Box sx={{ width: "14px", height: "14px", marginRight: "5px" }}>
            <img style={{ width: "100%" }} src={Images.coin} />
          </Box>
          <Typography color="textPrimary" className="fs-18" align="left">
            Swap HBAR to {brandName}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            setHBARORUDSC("udsc");
            setOpen(true);
          }}
        >
          <Box sx={{ width: "14px", height: "14px", marginRight: "5px" }}>
            <img style={{ width: "100%" }} src={Images.coin} />
          </Box>
          <Typography color="textPrimary" className="fs-18" align="left">
            Swap USDC-Polygon to {brandName}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin: "5px",
            cursor: "pointer",
          }}
          onClick={() => handleClickOpen()}
        >
          <Box sx={{ width: "14px", height: "14px", marginRight: "5px" }}>
            <img style={{ width: "100%" }} src={Images.coin} />
          </Box>
          <Typography color="textPrimary" className="fs-18" align="left">
            MoonPay to {brandName}
          </Typography>
        </Box>
      </div>
      <div style={{ position: "absolute", bottom: "0", width: "100%" }}>
        <Typography color="textPrimary" variant="h5" align="center">
          All the token/coin transfers will be converted to {brandName} token.
        </Typography>
        <Typography color="textPrimary" variant="h5" align="center">
          {brandName} price: 0.05 USD
        </Typography>
      </div>
      <React.Fragment>
        <Drawer
          style={{ background: "#1E1E1E" }}
          sx={{ height: "100vh" }}
          anchor={"bottom"}
          open={open}
          onClose={() => setOpen(false)}
        >
          <QrCode params={params} value={HBARORUDSC} />
        </Drawer>
      </React.Fragment>
      <AddSikiModal
        open={openModal}
        token={params["token"]}
        handleClose={handleClose}
      />
      {fundingLink ? (
        <div className="__moonpay">
          <iframe
            allow="accelerometer; autoplay; camera; gyroscope; payment"
            height="100%"
            src={fundingLink}
            width="100%"
          >
            <p>Your browser does not support iframes.</p>
          </iframe>
        </div>
      ) : null}
    </Box>
  );
}
